import React from "react";
import {
  withStyles,
  IconButton,
  MenuItem,
  Hidden,
  Menu
} from "@material-ui/core";
import { Person, Dashboard } from "@material-ui/icons";

import { Link } from 'react-router-dom'

//import { IconButton as SearchButton } from "../../components";

import headerLinksStyle from "../../variables/styles/headerLinksStyle";

class HeaderLinks extends React.Component {
  state = {
    open: false,
    anchorEl: null,
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLogout() {

     this.setState({ anchorEl: null });

    this.props.logout(() => {
       console.log('Logout');
      this.props.history.push('/');
    }, () => null);

  }


  render() {
    const { classes, userName } = this.props;
    //open,
    const { anchorEl } = this.state;
    return (
      <div style={{
        marginTop: '30px',
        display: 'flex',
        height: '44px',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {/*  <CustomInput
          formControlProps={{
            className: classes.top + " " + classes.search
          }}
          inputProps={{
            placeholder: "Search",
            inputProps: {
              "aria-label": "Search"
            }
          }}
        />
      <SearchButton
          color="white"
          aria-label="edit"
          customClass={classes.top + " " + classes.searchButton}
        >
          <Search className={classes.searchIcon} />
        </SearchButton> */}
        <IconButton
          component={Link}
          to="/dashboard"
          color="inherit"
          aria-label="Dashboard"
          className={classes.buttonLink}
        >
          <Dashboard className={classes.links} />
          <Hidden mdUp>
            <p className={classes.linkText}>Dashboard</p>
          </Hidden>
        </IconButton>
        <div style={{ height: '36px'}}>
        {userName}
        </div>
        <IconButton
          color="inherit"
          aria-label="Person"
          aria-owns={anchorEl ? 'simple-menu' : null}
          className={classes.buttonLink}
          onClick={e => this.handleClick(e)}
        >
          <Person className={classes.links} />
          <Hidden mdUp>
            <p className={classes.linkText}>Profile</p>
          </Hidden>
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => this.handleClose()}
        >
        {/*  <MenuItem onClick={() => this.handleClose()}>Profile</MenuItem>
          <MenuItem onClick={() => this.handleClose()}>My account</MenuItem> */}
          <MenuItem onClick={() => this.handleLogout()}>Logout</MenuItem>
        </Menu>

      </div>
    );
  }
}

export default withStyles(headerLinksStyle)(HeaderLinks);
